__turbopack_context__.v({
  "blink": "Introduction-module-scss-module__jEv7eq__blink",
  "introduction": "Introduction-module-scss-module__jEv7eq__introduction",
});
